import { StageType } from '$extensionSrc/utils/enums'

import { INSTAGRAM_AUTOMATION_STAGE_STATUSES } from './instagramAutomationStageStatuses'
import { settingsHomeUrl } from './instagramUrls'
import { StageDef } from '../automationMachineInterfaces'
import { getUrlChangePromise } from '../interruptiblePromises'
import { getElement } from '../utils'

/**
 * Instagram has recently done several settings url migrations.
 * This has made it difficult to navigate to the correct page by URL.
 * Rather than relying on that, we introduce this utility to also allow us
 * to try to navigate to the settings page from the menu. This may be
 * more robust than URL (though admittedly relies on consistent menu labels).
 */
export function goToInstagramSettingPageStageDefs(
  stageKey: string,
  label: string,
  fallbackUrl: string,
): StageDef[] {
  return [
    {
      type: StageType.ACTION,
      key: `${stageKey}_GO_TO_SETTINGS_HOME`,
      status: INSTAGRAM_AUTOMATION_STAGE_STATUSES.CHANGING_PAGES,
      url: settingsHomeUrl,
      action: async (machineContext, userContext, additionalMachineData) => {
        const { persistentData } = additionalMachineData
        await persistentData.set({
          ...persistentData.data,
          hasNavigated: false,
        })
      },
    },
    {
      type: StageType.ACTION,
      key: `${stageKey}_GO_TO_SETTINGS_URL`,
      status: INSTAGRAM_AUTOMATION_STAGE_STATUSES.GATHERING_SETTINGS,
      action: async (machineContext, userContext, additionalMachineData) => {
        const { persistentData } = additionalMachineData

        const settingsLink = await getElement<HTMLAnchorElement>(
          document,
          `.//a[descendant::span[contains(text(), "${label}")]]`,
        )

        if (!persistentData?.data?.hasNavigated) {
          await persistentData.set({
            ...persistentData.data,
            hasNavigated: true,
          })

          const waitForUrlChange = getUrlChangePromise()
          window.location.assign(settingsLink?.href || fallbackUrl)
          await waitForUrlChange
        }
      },
    },
  ]
}
